import { transformVegobjekttypeStedfesting } from './stedfesting';
import {
    Relasjon,
    Relasjonstype,
    Vegobjekttype,
} from '@/domain/vegobjekter/Vegobjekttype';
import { transformEgenskapstype } from './egenskapstype';
import type {
    Assosiasjonstype as ApiAssosiasjonstype,
    Relasjonstyper as ApiRelasjonstyper,
    Vegobjekttype as ApiVegobjekttype,
} from '@/generated/nvdb/datakatalog/models';

type ApiVegobjekttypeResponse = Omit<
    ApiVegobjekttype,
    'relasjonstyper' | 'stedfesting'
> & {
    relasjonstyper?: ApiRelasjonstyper | null;
    stedfesting?: ApiVegobjekttype['stedfesting'] | null;
};

export function transformVegobjekttype(data: ApiVegobjekttypeResponse): Vegobjekttype {
    return new Vegobjekttype(
        data.id,
        data.navn ?? '',
        data.kortnavn ?? '',
        data.beskrivelse ?? '',
        transformVegobjekttypeStedfesting(data.stedfesting),
        data.veiledning ?? '',
        data.sosinvdbnavn ?? '',
        data.sorteringsnummer,
        data.tidsrom_relevant,
        data.konnekteringslenke_ok ?? false,
        data.abstrakt_type,
        data.avledet,
        data.må_ha_mor,
        data.er_dataserie,
        (data.egenskapstyper || []).map(e => transformEgenskapstype(e)),
        !data.relasjonstyper
            ? new Relasjonstype([], [])
            : new Relasjonstype(
                  data.relasjonstyper.barn.map(transformRelasjon),
                  data.relasjonstyper.foreldre.map(transformRelasjon)
              ),
        data.sensitiv
    );
}

function transformRelasjon(relasjon: ApiAssosiasjonstype): Relasjon {
    const type = relasjon.type ?? relasjon.innhold?.type;
    if (!type) throw new Error('Relasjon mangler vegobjekttype');

    const innholdType = relasjon.innhold?.type ?? type;

    return new Relasjon(
        relasjon.id,
        relasjon.innenfor_mor ?? '',
        {
            id: type.id,
            navn: type.navn ?? '',
        },
        {
            type: {
                id: innholdType.id,
                navn: innholdType.navn ?? '',
            },
        },
        relasjon.relasjonstype ?? ''
    );
}
